import { Routes } from '@angular/router';

export const messageRoutes: Routes = [
  {
    path: 'errors',
    loadComponent: () => import('./message-errors.component').then((m) => m.MessageErrorsComponent),
  },
];
